import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchLowInventories, fetchWorkingOrders } from '../../actions/inventories_actions';
import { fetchRelatedProducts } from '../../actions/products_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import ProductConvertReport from '../../components/Inventories/productConvert';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

const productConvertReport = reduxForm({
  form: 'productConvertReport',
  destroyOnUnmount: false,
})(ProductConvertReport);

const selector = formValueSelector('productConvertReport');

function mapStateToProps(state) {
  const PackageSize = selector(state, 'PackageSize');
  const Stock = selector(state, 'Stock');
  const EffectDate = selector(state, 'EffectDate');
  return {
    PackageSize,
    Stock,
    EffectDate,
    lowInventoriesIsLoading: state.inventories.lowInventoriesIsLoading,
    lowInventories: state.inventories.lowInventories,
    lowInventoriesError: state.inventories.lowInventoriesError,
    workingOrdersIsLoading: state.inventories.workingOrdersIsLoading,
    workingOrders: state.inventories.workingOrders,
    workingOrdersError: state.inventories.workingOrdersError,
    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
  };
}

export default connect(mapStateToProps, {
  fetchLowInventories,
  fetchWorkingOrders,
  fetchRelatedProducts,
  setDefaultOfForm,
  checkPassword,
  clearCheckPassword,
})(productConvertReport);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/productConvert.jsx